import { Rocket, Linkedin, Globe } from "lucide-react";

/** Pure derivation of publish-channel availability + hint copy. No side effects. */
export function computeChannelOptions({ draft, linkedinReady, liConnected, liHasOrgId, websiteReady, blogGenerated, websiteHost }) {
  const liDone = !!draft?.linkedin_post_id;
  const blogDone = !!draft?.blog_url;
  const liAvailable = linkedinReady && !liDone;
  const blogAvailable = websiteReady && blogGenerated && !blogDone;

  const linkedinHint = liDone
    ? "Already on LinkedIn"
    : linkedinReady
      ? "Publishes to your Company Page"
      : !liConnected
        ? "Connect LinkedIn in Settings to enable one-click publish"
        : !liHasOrgId
          ? "Set your LinkedIn Organization ID in Settings"
          : "LinkedIn needs reconnecting in Settings";

  const options = [
    {
      id: "linkedin",
      label: "LinkedIn only",
      icon: Linkedin,
      disabled: !liAvailable,
      hint: linkedinHint,
    },
    {
      id: "blog",
      label: "Website blog only",
      icon: Globe,
      disabled: !blogAvailable,
      hint: blogDone ? "Already on the blog" : !websiteReady ? "Website publisher not configured" : !blogGenerated ? "Generate the blog version first" : `Publishes to ${websiteHost || "the website"}`,
    },
    {
      id: "both",
      label: "Both channels",
      icon: Rocket,
      disabled: !liAvailable || !blogAvailable,
      hint: !liAvailable && !blogAvailable ? "Both channels unavailable" : !liAvailable ? "LinkedIn unavailable" : !blogAvailable ? "Blog unavailable" : "LinkedIn Page + Website blog in one go",
    },
  ];

  return { options, liAvailable, blogAvailable };
}
